$ = require 'jquery'
_ = require 'underscore'
BoardCollectionsSelectView = require 'views/board-menu/board-collections-select-view'
BoardAddToTeamView = require 'views/board-menu/board-add-to-team-view'
Auth = require 'db/auth'
Controller = require 'controller'
localizeCount = require 'lib/localize-count'
ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
Util = require 'lib/util'
View = require 'view'
l = require 'lib/localize'
t = require('views/internal/teacup-with-helpers')('board_collections')
xtend = require 'xtend'
track = require 'debug/track'

spinnerTemplate = t.renderable ->
  t.div ->
    t.div '.spinner.loading'

class SpinnerView extends View
  render: ->
    @$el.html(spinnerTemplate())

class OnlyForTeamMembers extends View
  vigor: @VIGOR.NONE
  renderOnce: ->
    @$el.html t.render =>
      t.div '.count-explanation', =>
        t.p =>
          t.format 'only-team-members-can-enable-collections'

module.exports = class BoardCollectionsView extends View
  viewTitleKey: 'collections'
  noPadding: true

  className: 'board-menu-content-frame board-collections-view'

  initialize: ->
    @sidebarView = @options.sidebarView

    @listenTo @model, 'team-has-bc', =>
      @redirecting = false
      @addToTeam = false
      @render()
    @listenTo @model, 'added-to-team', =>
      @redirecting = true
      @render()
    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()
    @listenTo @model, 'cancel-upgrade', =>
      @initialViewState = null
      @render()
    @listenTo @model, 'add-to-team', =>
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @initialViewState = null
        @addToTeam = true
        @render()

  render: ->
    @$el.empty()

    board = @model
    boardBelongsToTeam = board.hasOrganization()
    team = board.getOrganization()
    me = Auth.me()

    isBoardMember = board.isMember(me)
    isTeamMember = team?.isMember(me)
    notMember = !isBoardMember && !isTeamMember
    publicBoardAndTeam = board.isPublic() && team?.isPublic()
    shouldRenderOnlyForTeamMembers = (
      boardBelongsToTeam && (
        (isBoardMember && !isTeamMember) ||
        (notMember && publicBoardAndTeam)
      )
    )

    if @redirecting
      @renderSpinner()
    else if @addToTeam
      @renderAddToTeam()
    else if shouldRenderOnlyForTeamMembers
      @renderOnlyForTeamMembers()
    else
      @renderTagSelect()

    @

  renderOnlyForTeamMembers: ->
    @appendSubview @subview(OnlyForTeamMembers, @model)
    return @

  renderSpinner: ->
    @appendSubview @subview(SpinnerView, @model)
    return @

  renderAddToTeam: ->
    if @model.hasOrganization()
      # So the board is part of a team, we just can't see it
      # This is a weird situation; we're just not going to let them
      # mess with the power-ups in this case
      @appendSubview @subview(OnlyForTeamMembers, @model)
      return @

    ModelLoader.loadMyOrganizations()

    @appendSubview @subview(BoardAddToTeamView, @model, {
      menuType: "Collections"
    })

  renderTagSelect: ->
    @appendSubview @subview(BoardCollectionsSelectView, @model, {
      @modelCache,
      @sidebarView
    })



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-collections-view.coffee